(function () {

    'use strict';
    angular.module('app').controller('accountsController',['$scope', '$sce', '$location', '$uibModal', '$cookies', 'stateService', 'accountsService',accountsController]);

    function accountsController($scope, $sce, $location, $uibModal, $cookies, stateService, accountsService) {
        //$scope.model = stateService.model;
        $scope.model = {};
        $scope.firstRun = true;
        function pagerButton(text, page, enabled, current) {
            this.text = $sce.trustAsHtml(text + '');
            this.page = page;
            this.enabled = enabled;
            this.current = current;
            if(!$scope.firstRun)
            $cookies.put("SsoAccountsPage", page);
        }

        function pager(response) {

            this.count = response.count;
            this.total = response.total;
            this.pageSize = response.count;

            this.totalPages = response.totalPages;
            this.currentPage = response.currentPage;
            this.canPrev = this.currentPage > 1;
            this.canNext = this.currentPage < this.totalPages;

            this.buttons = [];

            var totalButtons = 7; // ensure this is odd
            var pageSkip = 10;
            var startButton = 1;
            if (this
                .currentPage >
                Math.floor(totalButtons / 2)) startButton = this.currentPage - Math.floor(totalButtons / 2);

            var endButton = startButton + totalButtons - 1;
            if (endButton >= this.totalPages) endButton = this.totalPages;
            if (this.totalPages > totalButtons &&
            (endButton - startButton + 1) < totalButtons) {
                startButton = endButton - totalButtons + 1;
            }

            var prevPage = this.currentPage - pageSkip;
            if (prevPage < 1) prevPage = 1;

            var nextPage = this.currentPage + pageSkip;
            if (nextPage > this.totalPages) nextPage = this.totalPages;

            this.buttons.push(new pagerButton('<strong>&lt;&lt;</strong>', 1, this.currentPage != 1));
            this.buttons.push(new pagerButton('<strong>&lt;</strong>', prevPage, this.currentPage != 1));

            for (var i = startButton; i <= endButton; i++) {
                this.buttons.push(new pagerButton(i, i, true, i === this.currentPage));
            }

            this.buttons.push(new pagerButton('<strong>&gt;</strong>',
                nextPage,
                endButton <= this.totalPages && this.currentPage !== this.totalPages));
            this.buttons.push(new pagerButton('<strong>&gt;&gt;</strong>',
                this.totalPages,
                endButton <= this.totalPages && this.currentPage !== this.totalPages));
        }

        function impersonate(userId) {
            window.location = 'impersonate/' + userId;
        }

        $scope.impersonate = impersonate;

        $scope.getAccounts = function (filter, page) {
            if (filter) {
                $scope.model.filterApplied = true;
            } else {
                $scope.model.accounts = [];
                $scope.firstRun = false;
                return;
            }

            var count = 10;
            var start = page;

            $scope.model.waiting = true;
            $scope.model.pager = null;
            $scope.model.accounts = [];

            $cookies.put("SsoAccountsSearch", filter);

            if ($scope.firstRun) {
                var pageValue = $cookies.get("SsoAccountsPage");

                if (pageValue)
                   start = pageValue;

                $scope.firstRun = false;
            }
            accountsService.getAccounts(filter, start, count).then(function (response) {

                
                $scope.model.accounts = response.accounts.map(function(item) {
                    switch (item.type) {
                        case 0:
                            item.friendlyType = "User";
                            break;
                        case 1:
                            item.friendlyType = "Company Admin";
                            break;
                        case 2:
                            item.friendlyType = "Partner Admin";
                            break;
                        case 3:
                            item.friendlyType = "Partner Super Admin";
                            break;
                        case 4:
                            item.friendlyType = "Admin";
                            break;
                        case 5:
                            item.friendlyType = "Super Admin";
                            break;
                    }

                    return item;
                });

                    if (response.accounts && response.accounts.length) {
                        $scope.model.pager = new pager(response);
                    }

                    $scope.model.waiting = false;
                });
        };

        $scope.editAccount = function (accountId) {
            $location.url('/account/' + accountId);
        };

        $scope.clearFilter = function () {
            $scope.model.filter = '';
            $scope.model.filterApplied = false;
            $cookies.put("SsoAccountsSearch", '');
            $scope.getAccounts($scope.model.filter, 1);
        };
        $scope.exportNewAccounts = function () {
            var modalInstance = $uibModal.open({
                templateUrl: './assets/templates/modals/export_accounts.html',
                controller: 'exportAccountsController',
                size: 'md'

            });
        };

        $scope.deleteAccount = function (accountId, email) {
            var modalInstance = $uibModal.open({
                templateUrl: 'assets/templates/modals/confirmation_dialog.html',
                controller: 'deleteAccountsController',
                size: 'md',
                resolve: {
                    emailToDelete: function () {
                        return email;
                    },
                    accountIdToDelete: function () {
                        return accountId;
                    }
                }
            });

            modalInstance.result.then(function (response) {
                if (response.delete) {
                    accountsService.deleteAccount(response.accountId)
                        .then(function () {
                            $scope.reloadAccounts();
                        });
                }
            });
        };

        $scope.reloadAccounts = function () {

            var filterValue = $cookies.get("SsoAccountsSearch");
         

            if (filterValue)
                $scope.model.filter = filterValue;

            if ($scope.model.filter != undefined && $scope.model.filter != '') {
                var currentPage = 1;

                if ($scope.model.pager)
                    currentPage = $scope.model.pager.currentPage;

                $scope.getAccounts($scope.model.filter, currentPage);
            } else {
                $scope.getAccounts('', 1);
            }

          
        };

        accountsService.getAuthenticatedAccount().then(function (response) {
                $scope.model.isAdmin = (response.accountType === AccountType.Admin || response.accountType === AccountType.SuperAdmin);
                $scope.model.isPartnerAdmin = response.accountType === AccountType.Partner || response.accountType === AccountType.PartnerSuperAdmin;
                $scope.model.isPartnerSuperAdmin = response.accountType === AccountType.PartnerSuperAdmin;
                $scope.model.isSuperAdmin = (response.accountType === AccountType.SuperAdmin);
                $scope.model.isCompanyAdmin = response.accountType === AccountType.Company;
                $scope.model.authenticatedAccountId = response.accountId;
                $scope.model.companyId = response.companyId;

                $scope.model.authenticatedAccountRole = response.accountType;
            $scope.model.isImpersonating = response.isImpersonating;
        });

        $scope.reloadAccounts();
    }
})();